import React from 'react';
import PropTypes from 'prop-types';
import PulseLoader from 'react-spinners/PulseLoader';
import { useTranslation } from 'react-i18next';
import './_styles_/Spinner.css';
import { joinClassNames } from '../utils';

Spinner.propTypes = {
    className: PropTypes.string,
    displayLabel: PropTypes.bool,
    size: PropTypes.number,
    fixed: PropTypes.bool,
};

function Spinner(props) {
    const {
        className = null,
        displayLabel = true,
        size = 15,
        fixed = false,
    } = props;
    const { t } = useTranslation();
    const label = t('misc.loading');
    return (
        <div className={joinClassNames('loading-spinner', fixed && 'loading-spinner--fixed', className)} aria-label={label} title={label}>
            {displayLabel && <span className="loading-spinner--label">{label}</span>}
            <PulseLoader size={size} color="#1b486d" loading />{/* color references to "--color-100-primary" css variable */}
        </div>
    );
}

export default Spinner;
